import { render, staticRenderFns } from "./recruitment-business.vue?vue&type=template&id=525cd730&scoped=true"
import script from "./recruitment-business.vue?vue&type=script&lang=js"
export * from "./recruitment-business.vue?vue&type=script&lang=js"
import style0 from "./recruitment-business.vue?vue&type=style&index=0&id=525cd730&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525cd730",
  null
  
)

export default component.exports